(function(e,t,n){var r=e.querySelectorAll("html")[0];r.className=r.className.replace(/(^|\s)no-js(\s|$)/,"$1js$2")})(document,window,0);

$(window).on('load', function(){
  var $tree = $('#tree'), treeInstance,
      $rcont      = $('#room-container'),
      $containers = $('#room-container, #referencecard-container, #contactcard-container, #dealcard-container'),
      edited    = {},
      dealdarab = $('.newdeal').length,
      $hpcont   = $('#homepage-container');

  $('.roomadd').on('click', function (e) {
    var $this = $(this),
        $el   = $this.closest('.edited-cards'),
        data  = $el.data();

    var $isvalid = $('[data-abide]', $rcont).filter(function() {
      return !$(this).data('zfPlugin').validateForm();
    }).length;

    if($isvalid)
      return swal('Hiba!', 'Minden korábbi mező kitöltése kötelező!', 'warning');

    $this.addClass('disabled');
    $.post(seturl('roomadd'), {}, function(result) {
      $rcont.append(initContentFields(result.html));
    }).always(function(xhr) {
      $this.removeClass('disabled');
    });
  });

  if(dealdarab >= 5)
    $('.add[data-type=deal]').addClass('disabled');

  $('.zurb').on('click', '.add[data-type]:not(.disabled)', function(e) {
    var $this = $(this),
        type  = $this.data('type'),
        $el = $('#'+type+'card-container');

    $this.addClass('disabled');
    $.post(seturl('add',type), {}, function(result) {
      $el.prepend(initContentFields(result.html)).fadeIn(500, function () {
          if(type === 'deal') {
            var dealdarab = $('.newdeal', $el).length;
            //$('.dealcounter', $this).html(dealdarab);
            //&& $('.newdeal', $el).length >= 5
            dealdarab < 5 && $this.removeClass('disabled');
          }
            //$('.counter').html(result.dealdarab);
            //if (result.dealdarab >= 5)
            //  $('.dealadd').addClass('disabled').attr('disabled', true);
        });

    }).always(function(xhr) {
      if(type !== 'deal' ) $this.removeClass('disabled');
    });
  });

  $containers.on('click', '.ready .del', function(e) {
    var $this = $(this),
        $el   = $this.closest('.edited-cards'),
        url   = $el.data('url'),
        data  = form2js($el[0], '.', false),
        partnerid = gpid($el);

    if(partnerid)
      data.partnerid = partnerid;

    confirmDel(function(result){
      $el.addClass('disabled').removeClass('ready');
      $.post(seturl($el,'delete'), data, function(result) {
        $el.fadeOut(500, function() {
          $el.remove();
          var dealdarab = $('.newdeal').length;
          dealdarab < 5 &&  $('.add[data-type=deal]').removeClass('disabled');
        });
      }).fail(function(xhr) {
        $el.removeClass('disabled').addClass('ready');
      });
    });

  }).on('click', '.ready.edited .save', function(e) {
    var $this = $(this),
        $el   = $this.closest('.edited-cards'),
        url   = $el.data('url'),
        data  = form2js($el[0], '.', false),
        partnerid = _.get($,'ajaxSettings.data.partnerid');

    const image_id_elem = $this.closest("form").find(".deal-image-id");

    if ( typeof image_id_elem !== 'undefined' && image_id_elem.length > 0 && image_id_elem.attr('value').length <= 0 ) {
      swal('Hiba!', 'Kérem töltsön fel egy képet az ajánlathoz!', 'warning');
      return;
    }

    if(partnerid) {
      data.partnerid = partnerid;
    }

    if(!$($el).data('zfPlugin').validateForm()) {
      return;
    }

    $el.addClass('disabled').removeClass('ready');

    $.post(seturl($el,'save'), data, function(result) {
      if (result.error) {
        swal('Hiba!', result.error, 'warning');
      }

      $el.replaceWith(initContentFields(result.html));
      var $els = $('[data-id='+result.id+'][data-url='+url+'].edited-cards');

      if($els.length > 1) {
        $els.last().fadeOut(1000, function () {
          $(this).remove();
        });
      }
    }).fail(function(xhr) {
      $el.removeClass('disabled').addClass('ready');
    });

  }).on('change keyup keypress', '.ready input, .ready textarea, .ready select', function(e) {
    var $this = $(this),
        $el   = $this.closest('.edited-cards');
    $el.addClass('edited');
    $('.save', $el).removeClass('disabled');
  });


  $('.sorting-rooms').sortable({
    handle:     '.dd',
    animation:  50,
    ghostClass: 'ghost',
    onUpdate: function (e) { $.post(seturl('roomsort'), { sort: this.toArray() }) },
  });

  $('.disableothers').on('click', function() {
    var attr = $(this).closest('.input-group').find('input.othersadd').attr('disabled');
    $(this).toggleClass('success alert').closest('.input-group').find('input.othersadd').attr('disabled', !attr).val(!attr?'':0);
  });

  let descClearer = {};

  $('.enable-editable .editbutton').on("click", function(e) {
    var $cont = $(this).closest('.enable-editable');
    $cont.addClass('active');
    var data = $('.details-description', $cont).data();
    data.text = $('[data-content-edit]',$cont).attr('contenteditable', 'true').text();
    $('.edit-actions',$cont).show(300);
    edited[data.contentEdit] = data;
    $('.catering_option').show(300);
    $('.catering-info').hide(300);

    const $descElem = $('.details-description');
    descClearer = setInterval( function() {
      $descElem.find('br').remove();
      $descElem.find('div').contents().unwrap();
    }, 50);
  });

  // ------------------------------------

  $('.enable-editable .edit-actions .button').on("click", function(e) {
    var $this = $(this),
        $cont = $this.closest('.enable-editable'),
        action = $this.data('action'),
        $edited = $('[data-content-edit]', $cont),
        $buttons = $('.edit-actions a.button',$cont),
        $field = $('.details-description', $cont).data('content-edit'),
        catering_type = $('[name=catering_type]', $cont).val(),
        partnerid = gpid($cont);

    if(action==="save") {
      var datasend = $('.details-description', $cont).data();
      datasend.lang = $('a[data-lang].active', $cont).data('lang');
      datasend.text = $('[data-content-edit]', $cont).text();
      if(catering_type)
        datasend.catering_type = catering_type;
      if(partnerid)
        datasend.partnerid = partnerid;
      $edited.addClass('disabled');
      $buttons.addClass('disabled');

      $.post(seturl('contentsave'), datasend, function (result) {
        if(false == result[0] || !(_.isPlainObject(result[1]) && _.isString(result[1].text) && result[1].lang===$('a[data-lang].active', $cont).data('lang') && result[1].field === $field)) return;
        result = result[1];
        $cont.removeClass('active');
        $edited.removeAttr('contenteditable').removeClass('disabled');
        $buttons.removeClass('disabled');
        $edited.html(result.text);
        $(".catering-info", $cont).html('<i class="icon-check"></i>&nbsp;'+result.catering_text);
        $('.edit-actions', $cont).hide(300);
        $('.catering_option').hide(300);
        $('.catering-info').show(300);
      });

      clearInterval(descClearer);
      return;
    }

    if(action==="cancel") {
      $cont.removeClass('active');
      $edited.html(edited[$field].text);
      delete edited[$field];
      $edited.removeAttr('contenteditable');
      $('.edit-actions', $cont).hide(300);
      $('.catering_option').hide(300);
      $('.catering-info').show(300);
      clearInterval(descClearer);
    }
  });


  $('a[data-lang]').on("click", function(e) {
    var $cont = $(this).closest('.enable-editable'),
        $edited = $('[data-content-edit]', $cont),
        datalang = $('.details-description', $cont).data(),
        partnerid = gpid($cont);
    $('a[data-lang].active', $cont).removeClass('active');
    datalang.lang = $(this).addClass('active').data('lang');
    $edited.removeAttr('contenteditable').addClass('disabled');
    $('.edit-actions a.button',$cont).addClass('disabled');
    if(partnerid)
      datalang.partnerid = partnerid;
    $.post(seturl('langselector'), datalang, function (result) {
      $edited.attr('contenteditable', true).removeClass('disabled');
      $('.edit-actions a.button',$cont).removeClass('disabled');
      edited[result.field].text = result.text;
      $edited.html(result.text);
      $('.currentlang', $cont)[0].style.backgroundImage = "url(https://static.rendezvenyhelyszinek.hu/images/lang/"+result.lang+".jpg)";
    });
  });

  function confirmDel(callback) {
    callback = _.isFunction(callback) ? callback : function(){};
    return swal({
      title: "Figyelem!",
      text:  "Biztos törölni szeretnéd?",
      type:  "question",
      showCancelButton:   true,
      cancelButtonText:   "Mégse",
      confirmButtonText:  "Igen!",
      confirmButtonColor: "#DD6B55"
    }).then(callback);
  }

  $('.type-container.ready').on('change', 'input.typeadd', function() {
    var $this = $(this),
        $el   = $this.closest('.type-container');
        $el.addClass('edited');
    $('a.button', $el).removeClass('disabled');
  }).on('click', 'a.button.save', function() {
    var $this = $(this),
        $el   = $this.closest('.type-container'),
        data  = {types: _.keys(form2js($el[0], '.', false).type)},
        partnerid = gpid($el);

    if(data.types.length < 1) {
      swal('Hiba!', 'Legalább egy helyszín jelleg megadása kötelező!', 'warning');
    } else {
      $el.removeClass('ready');
      $('a.button', $el).addClass('disabled');
      if(partnerid)
        data.partnerid = partnerid;
      $.post(seturl('typesave'), data, function (result) {
          $el.removeClass('edited');
      }).always(function(xhr) {
        $el.addClass('ready');
      }).fail(function(xhr) {
        $('a.button', $el).removeClass('disabled');
      });
    }});

  $('.prop-container.ready').on('change', 'input.propadd', function() {
      var $this = $(this),
          $el   = $this.closest('.prop-container');
      $el.addClass('edited');
      $('a.button', $el).removeClass('disabled');
  }).on('click', 'a.button.save', function() {
      var $this = $(this),
          $el   = $this.closest('.prop-container'),
          data  = {props: _.keys(form2js($el[0], '.', false).prop)};
          partnerid = gpid($el);

      $el.removeClass('ready');
      $('a.button', $el).addClass('disabled');

      if(partnerid) {
        data.partnerid = partnerid;
      }

      $.post(seturl('propsave'), data, function (result) {
          $el.removeClass('edited');
      }).always(function(xhr) {
          $el.addClass('ready');
      }).fail(function(xhr) {
          $('a.button', $el).removeClass('disabled');
      });
  });

  $('.homepage-container.ready').on('keyup change', 'input.homepageadd', function() {
      var $this = $(this),
          $el   = $this.closest('.homepage-container');
      $el.addClass('edited').removeClass('ready');
      $('.button.save', $el).removeClass('disabled');
  }).on('click', '.button.save:not(.disabled)', function() {
      var $this = $(this),
          $el   = $this.closest('.homepage-container'),
          data  = form2js($el[0], '.', false);
          partnerid = gpid($el);

      $('.button.save', $el).addClass('disabled');

      if(partnerid) {
        data.partnerid = partnerid;
      }

      $.post(seturl('homepagesave'), data, function (result) {
        $el.removeClass('edited').find('input.homepageadd').val(_.first(result));
      }).always(function(xhr) {
        $el.addClass('ready');
      }).fail(function(xhr) {
        $('.button.save', $el).removeClass('disabled');
      });
  });

  var $sroom = $('[name="quarter_single_room"]'),
      $mroom = $('[name="quarter_multi_room"]'),
      $qroom = $('[name="quarter_max_person"]');

  if($mroom[0] || $sroom[0]) {
    $('[name="quarter_all"]').val(_.toInteger($sroom.val())+_.toInteger($mroom.val()))[0].disabled = true;
  }

  $('.others-container.ready').on('keyup keypress change', 'input', function() {
      var $this = $(this),
          $el   = $this.closest('.others-container');
      var $counter = _.toInteger($sroom.val())+_.toInteger($mroom.val());

      $el.addClass('edited');
      $('[name="quarter_all"]').val($counter);
      $('.button.save', $el).removeClass('disabled');
  }).on('click', '.button.save:not(.disabled)', function() {
      var $this = $(this),
          $el   = $this.closest('.others-container'),
          data  = form2js($el[0], '.', false),
          partnerid = gpid($el);
      $el.removeClass('ready');
      $('.button.save', $el).addClass('disabled');
      if(partnerid)
        data.partnerid = partnerid;
      $.post(seturl('otherssave'), data, function (result) {
          $el.removeClass('edited');
      }).always(function(xhr) {
          $el.addClass('ready');
      }).fail(function(xhr) {
          $('.button.save', $el).removeClass('disabled');
      });
  });

  $('#dealcard-container').on('click', '.approvalbutton.admin.warning', function(e) {
      var $this = $(this),
          $el = $this.closest('.edited-cards'),
          data  = $this.data(),
          partnerid = gpid($el);
      $('.approvalbutton').addClass('disabled');
      if(partnerid)
        data.partnerid = partnerid;
      $.post(seturl('dealapproval'), data, function (result) {
        if(result.approved)
          $('.approvalbutton', $el).toggleClass('warning primary active').html('Inaktiválás');
        $('.approvalbutton').removeClass('disabled');
      }).fail(function(xhr) {
        $this.removeClass('disabled');
        swal('Hiba!', 'A jóváhagyás nem sikerült!', 'warning');
      });
  }).on('click', '.approvalbutton.admin.primary.active', function(e) {
      var $this = $(this),
          $el = $this.closest('.edited-cards'),
          data  = $this.data(),
          partnerid = gpid($el);
      $('.approvalbutton').addClass('disabled');
      if(partnerid)
        data.partnerid = partnerid;
      $.post(seturl('dealinactivate'), data, function (result) {
        if(result.inactivated)
          $('.approvalbutton', $el).toggleClass('primary active warning inactive admin').html('Inaktív');
        $('.approvalbutton').removeClass('disabled');
      });
  });

});

function gpid($el) {
  return settings.get('meta.partnerid') || ($el && $($el).find('input[type="hidden"][name="partnerid"]').val());
}

function seturl() {
  var _args = _(Array.from(arguments)),
      urls  = _args.filter(_.property('[0].dataset.url')).pluck('[0].dataset.url').value(),
      args  = _args.filter(_.isString).map(settings.getMeta).value(),
      join  = _args.filter(_.property('join')).pluck('join').first() || '';

  return '/' + [ settings.getMeta('paurl'), !join && '/' ].concat(urls).concat(args).filter(_.isString).join(join);
}
